<script>
import {mapGetters} from 'vuex'

export default {
  name: 'StandardDetailReports',

  data () {
    return {}
  },

  computed: {
    ...mapGetters('Car', [
      'carByCarId',
      'mileageReportByCarId',
      'maintenanceRecordsByCarId',
      'attachmentListByCarId',
      'configurationChecksByCarId',
      'suppliesStatusByCarId',
      'outRepairListByCarId',
      'flawByCarId',
      'chassisByCarId',
      'chassis2ByCarId',
      'mileageReportStatusByCarId',
      'hasAttachmentListByCarId',
      'hasNewAttachMentListByCarId',
      'hasReportPreSalePreparation',
      'hasReportConsumable',
      'reportEquipmentById',
      'exteriorVideoById',
      'newEnergyByCarId',
      'metasByCarId',
    ]),

    // metas
    metas () {
      return this.metasByCarId(this.$route.params.id)
    },

    carId () {
      return this.$route.params.id
    },

    car () {
      return this.carByCarId(this.carId)
    },

    mileageReport () {
      return this.mileageReportByCarId(this.carId)
    },

    maintenanceRecords () {
      return this.maintenanceRecordsByCarId(this.carId)
    },

    attachmentList () {
      return this.attachmentListByCarId(this.carId)
    },

    configurationChecks () {
      return this.configurationChecksByCarId(this.carId)
    },

    suppliesStatus () {
      return this.suppliesStatusByCarId(this.carId)
    },

    outRepairList () {
      return this.outRepairListByCarId(this.carId)
    },

    flaw () {
      return this.flawByCarId(this.carId)
    },

    chassis () {
      return this.chassisByCarId(this.carId)
    },

    chassis2 () {
      return this.chassis2ByCarId(this.carId)
    },

    mileageReportStatus (){
      return this.mileageReportStatusByCarId(this.carId)
    },

    hasAttachmentList () {
      return this.hasAttachmentListByCarId(this.carId)
    },

    hasNewAttachmentList () {
      return this.hasNewAttachMentListByCarId(this.carId)
    },

    // reportPreSalePreparation
    reportPreSalePreparation () {
      return this.hasReportPreSalePreparation(this.carId)
    },

    // reportConsumable
    reportConsumable () {
      return this.hasReportConsumable(this.carId)
    },

    // reportEquipment
    reportEquipment () {
      return this.reportEquipmentById(this.carId)
    },

    // exteriorVideo
    exteriorVideo () {
      return this.exteriorVideoById(this.carId)
    },

    // newEnergy
    newEnergy () {
      return this.newEnergyByCarId(this.carId)
    },
  },
}
</script>

<template>
  <div class="section-content section-content-category-report">
    <div class="category-report-wrapper">
      <!-- 销售组 START -->
      <!-- 'old_has' -->
      <div class="category-report-section">
        <div class="category-report-hd">
          <div class="category-report-title">
            收购部
          </div>
        </div>

        <div class="category-report-bd">
          <template v-if="mileageReportStatus == 'old_has'">
            <!-- 里程走势 -->
            <router-link
              :to="{
                name: 'CarCategroyReport',
                params: {
                  name: 'mileageReport'
                },
              }"
              :class="['category-report']">
              <div class="category-report-image" />
              <div class="category-report-desc">
                里程曲线 »
              </div>
            </router-link>
            <!--/ 里程走势 -->

            <!-- 维保记录 -->
            <template v-if="maintenanceRecords">
              <router-link
                :to="{
                  name: 'CarCategroyReport',
                  params: {
                    name: 'mileageReport'
                  },
                }"
                :class="['category-report']"
                :data-name="['maintenanceRecords']">
                <div class="category-report-image" />
                <div class="category-report-desc">
                  维保记录 »
                </div>
              </router-link>
            </template>
            <template v-else>
              <div
                :class="[
                  'category-report',
                  'category-report-empty'
                ]">
                <div class="category-report-image" />
                <div class="category-report-desc">
                  维保记录 »
                </div>
              </div>
            </template>
            <!--/ 维保记录 -->
          </template>

          <template v-if="mileageReportStatus == 'new_null'">
            <div
              :class="[
                'category-report',
                'category-report-empty'
              ]"
              data-name="maintenanceRecords">
              <div class="category-report-image" />
              <div class="category-report-desc">
                维保记录 »
              </div>
            </div>
          </template>

          <template v-if="mileageReportStatus == 'new_has'">
            <router-link
              :to="{
                name: 'StandardReportMileage',
              }"
              :class="['category-report']">
              <div class="category-report-image" />
              <div class="category-report-desc">
                维保记录 »
              </div>
            </router-link>
          </template>
          <!--/ 维保记录 -->

          <!-- 附件清单 -->
          <template v-if="hasAttachmentList">
            <template v-if="hasNewAttachmentList">
              <router-link
                :to="{
                  name: 'StandardReportAccessory',
                  params: {
                    id: carId,
                  },
                }"
                :class="['category-report']">
                <div class="category-report-image" />
                <div class="category-report-desc">
                  附件清单 »
                </div>
              </router-link>
            </template>
            <template v-else>
              <router-link
                :to="{
                  name: 'CarCategroyReport',
                  params: {
                    name: 'attachmentList'
                  },
                }"
                :class="['category-report']">
                <div class="category-report-image" />
                <div class="category-report-desc">
                  附件清单 »
                </div>
              </router-link>
            </template>
          </template>
          <template v-else>
            <div
              :class="[
                'category-report',
                'category-report-empty'
              ]">
              <div class="category-report-image" />
              <div class="category-report-desc">
                附件清单 »
              </div>
            </div>
          </template>
          <!--/ 附件清单 -->
        </div>
      </div>

      <!-- 质检组 -->
      <div class="category-report-section">
        <div class="category-report-hd">
          <div class="category-report-title">
            质检部
          </div>
        </div>

        <div class="category-report-bd">
          <!-- 功能配置单 -->
          <!-- <template v-if="!reportEquipment">
            <template v-if="configurationChecks">
              <router-link
                :to="{
                  name: 'CarCategroyReport',
                  params: {
                    name: 'configurationChecks'
                  },
                }"
                :class="[
                  'category-report',
                ]">
                <div class="category-report-image" />
                <div class="category-report-desc">
                  功能配置单 »
                </div>
              </router-link>
            </template>
            <template v-else>
              <div
                :class="[
                  'category-report',
                  'category-report-empty'
                ]">
                <div class="category-report-image" />
                <div class="category-report-desc">
                  功能配置单 »
                </div>
              </div>
            </template>
          </template> -->
          <!--/ 功能配置单 -->

          <!-- 耗材清单 -->
          <template v-if="reportConsumable">
            <!-- report consumable -->
            <router-link
              :to="{
                name: 'StandardReportConsumble',
                params: {
                  id: carId,
                },
              }"
              :class="['category-report']">
              <div class="category-report-image" />
              <div class="category-report-desc">
                耗材清单 »
              </div>
            </router-link>
          </template>
          <template v-else-if="suppliesStatus">
            <!-- report suppliesStatus -->
            <router-link
              :to="{
                name: 'CarCategroyReport',
                params: {
                  name: 'suppliesStatus'
                },
              }"
              :class="['category-report']">
              <div class="category-report-image" />
              <div class="category-report-desc">
                耗材清单 »
              </div>
            </router-link>
          </template>
          <template v-else>
            <!-- nothing -->
            <div
              :class="[
                'category-report',
                'category-report-empty',
              ]">
              <div class="category-report-image" />
              <div class="category-report-desc">
                耗材清单 »
              </div>
            </div>
          </template>
          <!--/ 耗材清单 -->

          <!-- pre sale preparation -->
          <!--
            - 2023.09.18
            - 跳转“整备清单”
            - 新版整备清单 reportPreSalePreparation
            - 旧版整备清单 outRepairList
            2024.09.25 诺式整备单
            - field 同"新整备清单": hasReportPreSalePreparation
            2024.10.11 诺式整备单
            - hide report if the car is typed `newEnergy`
          -->
          <template v-if="metas?.emission.value !== '纯电*'">
            <template v-if="reportPreSalePreparation">
              <!-- pre sale preparation -->
              <router-link
                :to="{
                  name: 'StandardReportRefurbishList',
                  params: {
                    id: carId,
                  },
                }"
                :class="[
                  'category-report',
                  'category-report--preparation',
                ]">
                <div class="i">新版</div>
                <div class="category-report-image" />
                <div class="category-report-desc">
                  诺式整备单 »
                </div>
              </router-link>
            </template>
            <!-- out repair list -->
            <!-- <template v-else-if="outRepairList">
              <router-link
                :to="{
                  name: 'CarCategroyReport',
                  params: {
                    name: 'outRepairList'
                  },
                }"
                :class="[
                  'category-report',
                  'category-report--preparation',
                ]">
                <div class="i">新版</div>
                <div class="category-report-image" />
                <div class="category-report-desc">
                  诺式整备单 »
                </div>
              </router-link>
            </template> -->
            <template v-else>
              <div
                :class="[
                  'category-report',
                  'category-report--preparation',
                  'category-report-empty',
                ]">
                <div class="category-report-image" />
                <div class="category-report-desc">
                  诺式整备单 »
                </div>
              </div>
            </template>
          </template>
          <!-- / pre sale preparation -->
        </div>
      </div>
      <!--/ 质检组 -->

      <!-- 发布组 -->
      <div class="category-report-section">
        <div class="category-report-hd">
          <div class="category-report-title">
            发布部
          </div>
        </div>

        <div class="category-report-bd">
          <!-- exterior video -->
          <!-- <template v-if="exteriorVideo">
            <router-link
              :to="{
                name: 'StandardExteriorVideo',
                params: {
                  id: carId,
                },
              }"
              :class="[
                'category-report',
                !exteriorVideo ? 'category-report-empty' : ''
              ]">
              <div class="category-report-image" />
              <div class="category-report-desc">
                绕车视频 »
              </div>
            </router-link>
          </template>
          <template v-else>
            <div
              :class="[
                'category-report',
                'category-report-empty'
              ]">
              <div class="category-report-image" />
              <div class="category-report-desc">
                绕车视频 »
              </div>
            </div>
          </template> -->
          <!--/ exterior video -->

          <!-- flaw -->
          <template v-if="flaw">
            <router-link
              :to="{
                name: 'StandardReportFlaw',
                params: {
                  id: carId,
                },
              }"
              :class="[
                'category-report',
                !flaw?'category-report-empty':''
              ]">
              <div class="category-report-image" />
              <div class="category-report-desc">
                瑕疵报告 »
              </div>
            </router-link>
          </template>
          <template v-else>
            <div
              :class="[
                'category-report',
                'category-report-empty'
              ]">
              <div class="category-report-image" />
              <div class="category-report-desc">
                瑕疵报告 »
              </div>
            </div>
          </template>
          <!--/ flaw -->

          <!-- chassis -->
          <template v-if="chassis || chassis2">
            <router-link
              :to="{
                name: 'StandardReportChassis',
                params: {
                  id: carId,
                },
              }"
              :class="[
                'category-report',
                !chassis && !chassis2 ? 'category-report-empty':''
              ]">
              <div class="category-report-image" />
              <div class="category-report-desc">
                底盘照片 »
              </div>
            </router-link>
          </template>
          <template v-else>
            <div
              :class="[
                'category-report',
                'category-report-empty'
              ]">
              <div class="category-report-image" />
              <div class="category-report-desc">
                底盘照片 »
              </div>
            </div>
          </template>
          <!--/ chassis -->
        </div>
      </div>
      <!--/ 发布组 -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
 /* 诺式报告 */
 .category-report-section {
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  justify-content: stretch;
  margin-bottom: 15px;
}

.category-report-section:last-child {
  margin-bottom: 0;
}

.category-report-hd {
  background: #248cdf;
  margin-right: 5px;
  display: flex;
  flex: 0 0  20px;
  user-select: none;
}

.category-report-title {
  width: 100%;
  color: #ffffff;
  // padding: 15px 2px 15px 2px;
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
  margin: auto;
  font-size: 0.9rem;
  writing-mode: vertical-rtl;
  text-orientation: upright;
  line-height: 1.325;
}

.category-report-bd {
  display: flex;
  flex: row nowrap;
  flex: 1;
  align-items: stretch;
  width: 100%;
}

.category-report {
  flex: 0 0 22%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  margin-right: 10px;
}

.category-report.category-report--preparation {
  overflow: visible;
  position: relative;
}

.category-report:hover {
  cursor: pointer;
}

.category-report.category-report-empty {
  > .i {
    display: none;
  }
}

.category-report {
  > .i {
    display: block;
    position: absolute;
    right: -12px;
    top: 0;
    font-size: 1.125rem;
    color: #212121;
    background-color: #FAFA5A;
    padding: 2px 5px;
    box-sizing: border-box;
    z-index: 2;
    border-radius: 2px;
  }
}

.category-report-image {
  width: 100%;
  // flex: 1;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.category-report-image::before {
  content: '';
  margin: 0 auto;
  width: 85%;
  background: #efefef;
  display: block;
  box-sizing: border-box;
  padding-bottom: calc(100% / 1 * 1.1);
}

.category-report-image::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background: url(http://static.nuonuo.com.cn/zycmp/standard-detail-report-icon-20230918.png)
    center center no-repeat;
  background-size: contain;
}

.category-report-desc {
  margin-top: 4px;
  font-size: .75rem;
  white-space: nowrap;
  color: #027BFF;
  padding: 4px 6px;
  display: flex;
  align-items: center;
  position: relative;
  border: .5px solid #027BFF;
  border-radius: 8px;
}

.category-report.category-report-empty {
  &:hover {
    cursor: unset;
  }

  .category-report-image::before {
    background: var(--background);
  }

  .category-report-image::after {
    background: transparent
      url('http://static.nuonuo.com.cn/zycmp/standard-detail-report-icon-20230918.png') center center
      no-repeat;
    background-size: contain;
    opacity: 0.6;
  }

  .category-report-desc {
    color: #b1b1b1;
    border-color: #B1B1B1;
  }

  .category-report-desc::after {
    border-color: #B1B1B1;
  }
}

.help-pre-sale-wrapper {
  border-bottom-right-radius: 0.8rem 0.7rem;
  background: rgba(253,238,135, 1);
  position: absolute;
  right: -80px;
  width: 65px;
  height: auto;
  z-index: 0;
  box-sizing: border-box;
  &:hover {
    cursor: pointer;
  }
}

.help-pre-sale {
  position: relative;
  background: rgba(253,238,135, 1);
  text-align: center;
}

.help-pre-sale:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 12px solid rgba(253,238,135, 1);
  border-right: 6px solid transparent;
  border-top: 6px solid rgba(253,238,135, 1);
  border-bottom: 10px solid transparent;
  left: -5px;
  bottom: -8px;
  transform: rotate(35deg);
  z-index: 0;
}

.help-pre-sale-text {
  position: relative;
  z-index: 100;
  padding: 5px;
  box-sizing: border-box;
  font-size: .8rem;
  white-space: nowrap;
  color: var(--blue-primary);
}

// report-contact-consultant-el
.report-contact-consultant-el {
  position: absolute;
  width: 70%;
  z-index: 50;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .category-report-desc {
    border: none;
  }

  .category-report-desc::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border: 1px solid #027BFF;
    transform: scale(0.5);
    transform-origin: 0 0;
    box-sizing: border-box;
    pointer-events: none;
    border-radius: 8px;
  }
}

@media (min-width: 640px) {
  .category-report {
    flex: 0 0 20%;
  }

  .category-report-desc {
    margin-top: 10px;
    font-size: .85rem;
    padding: 2px 8px;
  }

  .category-report-image::before {
    content: '';
    width: 75%;
    padding-bottom: 100%;
  }

  .category-report-image:hover::before {
    filter: brightness(.9);
  }

  .category-report-image::after {
    content: '';
    width: 85%;
  }

  .category-report {
    > .i {
      right: -8px;
    }
  }
}

@media (prefers-color-scheme: dark) {
  .category-report-hd {
    background: #0B304D;
  }

  .category-report-image::before {
    background: #1A1A1A;
  }

  .category-report-image::after {
    background: transparent url(https://static.nuonuo.com.cn/zycmp/standard-detail-report-icon-white-20241206.png) center no-repeat;
    background-size: 85%;
  }

  .category-report.category-report-empty .category-report-desc {
    color: #5F5F5F;
  }

  .category-report.category-report-empty .category-report-desc::after {
    border-color: #3A3A3A;
  }

  .category-report.category-report-empty .category-report-image::after {
    background: transparent url(https://static.nuonuo.com.cn/zycmp/standard-detail-report-icon-white-20241206.png) center no-repeat;
    background-size: 85%;
  }
}
</style>

